module.exports = __webpack_public_path__ + "img/Villa_Borna_19.f9c050f7.jpg";